import { StyledHeader, StyledText } from '@clickcease/cc-client-components-lib'
import { useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

import newGoogleConnectImage from '../../../../../../../assets/images/google-connect-new.png'
import { WrapperWithButtons } from '../../../../../../../components/Elements/WrapperWithButtons/WrapperWithButtons'
import { useApproveAccountId } from '../../../../../api/approveGoogleMCC'
import { useCancelGoogleMCCRequest } from '../../../../../api/cancelGoogleMCCRequest'
import { MCC_STATUSES } from '../../../../../models'
import { useUserStore } from 'Stores/userStoreModuleFed'

import { DescriptionContainer, StepsContainer } from './ApproveAccess.styled'
import React from 'react'

export const ApproveAccess = ({
  onSubmit,
  connectionId,
  onBack,
}: {
  onSubmit: () => void
  onBack: () => void
  connectionId: number
}) => {
  const { t } = useTranslation('PMPlatforms')
  const queryClient = useQueryClient()
  const { accountId } = useUserStore()

  const { mutate: cancelMccRequest } = useCancelGoogleMCCRequest()
  const { refetch, isFetching } = useApproveAccountId({
    connectionId: connectionId,
    config: {
      enabled: false,
      onSuccess: (data) => {
        if (!(data instanceof Error) && data.status === MCC_STATUSES.ACTIVE) {
          onSubmit()
        }
      },
    },
  })

  const checkStatus = async () => {
    await refetch()
  }

  const onBackClick = () => {
    cancelMccRequest(
      { accountId, connectionId },
      {
        onSuccess: async () => {
          await queryClient.invalidateQueries({ queryKey: ['getPlatforms'] })
          onBack()
        },
      }
    )
  }

  return (
    <WrapperWithButtons
      ghostButtonText={t('google-connection-wizard.cancel-mcc-request')}
      onGhostButtonClick={onBackClick}
      primaryButtonText={t('next-button')}
      onPrimaryButtonClick={checkStatus}
      isPrimaryButtonDisabled={isFetching}
    >
      <DescriptionContainer>
        <StyledHeader variant={'h4'}>{t('google-connection-wizard.step-2-title')}</StyledHeader>
        <StyledText variant={'baseLight'} css={{ marginTop: '$2' }}>
          {t('google-connection-wizard.step-2-explainer')}
        </StyledText>
      </DescriptionContainer>
      <StepsContainer>
        <img
          alt="Click Admin on the sidebar, then access and security. Click on managers tab and then click on accept on our access request."
          src={newGoogleConnectImage}
          width={'660px'}
        />
      </StepsContainer>
    </WrapperWithButtons>
  )
}
